// extracted by mini-css-extract-plugin
module.exports = {"container":"_2n4qWQJ8AhmsGVezWDXsbr","videoCard":"_2muq9mGG7BJ_irIWOf4zIO","loadingSkeleton":"_1ODIt5QDz_qX52hwAkX4HT"};